// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"styles_errorContainer__3SVVG"};